export default __webpack_public_path__ + "static/media/279.3edb5626.jpg";